<template>
  <div class="h-100 w-100">
    <keep-alive>
      <GenericHeader v-if="$route.name != 'devices' ? true : false"></GenericHeader>
      <DevicesHeader v-if="$route.name == 'devices' ? true : false"></DevicesHeader>
    </keep-alive>
    <keep-alive>
      <router-view class="body" v-keep-scroll-position></router-view>
    </keep-alive>
    <GenericNav></GenericNav>
  </div>
</template>

<script lang="ts">
import DevicesHeader from '@/components/headers/DevicesHeader.vue'
import GenericHeader from '@/components/headers/GenericHeader.vue'
import GenericNav from '@/components/GenericNav.vue'
import globalModule from '@/store/modules/global.module'

import { Component, Vue } from 'vue-property-decorator'
import mapsModule from '@/store/modules/maps.module'

@Component({
  components: { GenericNav, GenericHeader, DevicesHeader },
})
export default class Base extends Vue {
  mounted() {
    this.createInterval()
  }

  updated() {
    if (this.$route.path === '/maps') mapsModule.mapService.map.updateSize()
  }

  createInterval() {
    setInterval(() => {
      globalModule.refreshTime()
    }, 1000)
  }
}
</script>
<style lang="sass">
.body
  height: 100%
</style>
